/**
 * Created by why on 2019/10/21.
 */
/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const getNotepadByCondition = (data) => {
  return axios.request({
    url: '/notepad/getByCondition',
    params: data,
    method: 'get'
  })
}

export const getById = (id) => {
  return axios.request({
    url: `/notepad/getById/${id}`,
    method: 'get'
  })
}

export const notepadSave = (data) => {
  return axios.request({
    url: '/notepad/save',
    data: data,
    method: 'post'
  })
}

export const notepadEdit = (data) => {
  return axios.request({
    url: '/notepad/edit',
    data: data,
    method: 'post'
  })
}

export const notepadDelByIds = (ids) => {
  return axios.request({
    url: `/notepad/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/notepad-manage.js